import { NavLink } from 'react-router-dom';
import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaYoutube,
    FaTelegramPlane,
    FaMedium,
    FaWhatsapp,
    FaMapMarkerAlt,
    FaPhone,
    FaEnvelope
} from 'react-icons/fa';
import logo from '../images/KhetBazaar_logo_new_design.png';

import { COMMON_CONSTANTS } from '../constants/Common'
const { config: { phone, email } } = COMMON_CONSTANTS

const FooterComponent = () => {
    const currentYear = new Date().getFullYear();
    const isuserLoggedIn = localStorage.getItem('isLoggedIn')
    // console.log('logid in', isuserLoggedIn)

    const popularSearches = [
        "Farm Land For Sale",
        "Agri Industrial Lands",
        "Estate Land For Sale",
        "Sustainable Farm For Sale"
    ];

    const companyLinks = [
        { path: "/about", label: "About Us" },
        { path: "/faqs", label: "Basic FAQs" },
        // { path: "/plans", label: "Listing Plans" },
        { path: "/advanced-faqs", label: "Advanced FAQs" }
    ];

    const policyLinks = [
        { path: "/terms", label: "Terms & Conditions" },
        { path: "/privacy", label: "Privacy Policy" },
    ];

    const socialLinks = [
        { Icon: FaFacebook, url: "https://www.facebook.com/khet.bazaar.2025/", label: "Facebook" },
        { Icon: FaTwitter, url: "https://twitter.com", label: "Twitter" },
        { Icon: FaInstagram, url: "https://www.instagram.com/khet.bazaar/", label: "Instagram" },
        { Icon: FaYoutube, url: "https://www.youtube.com", label: "YouTube" },
        { Icon: FaTelegramPlane, url: "https://t.me/khetbazaar", label: "Telegram" },
        { Icon: FaMedium, url: "https://medium.com", label: "Medium" },
        { Icon: FaWhatsapp, url: "https://wa.me/8452912071", label: "WhatsApp" }
    ];

    return (
        <footer className="footer">
            {/* CTA Section */}
            {
                !isuserLoggedIn && (
                    <div className="footer-cta">
                        <div className="cta-content">
                            <img src={logo} alt="KhetBazaar Logo" className="footer-logo" />
                            <h2>Ready to get started?</h2>
                            <NavLink to="/signup" className="cta-button">
                                Get Started
                            </NavLink>
                        </div>
                    </div>

                )
            }

            {/* Main Footer Content */}
            <div className="footer-grid">
                {/* Address Section */}
                <div className="footer-column">
                    <h3>Address</h3>
                    <div className="contact-info">
                        <p>
                            <FaMapMarkerAlt className="contact-icon" />
                            Marol, Andheri East,
                            <br />Mumbai - 400059,
                            <br />Maharashtra, India.
                        </p>
                        <p>
                            <FaPhone className="contact-icon" />
                            <a href="tel:8019503344">{phone}</a>
                            <br />
                            {/* <a href="tel:04048585344">040-48585344</a> */}
                        </p>
                        <p>
                            <FaEnvelope className="contact-icon" />
                            <a href={email}>
                                {email}
                            </a>
                        </p>
                    </div>
                </div>

                {/* Popular Searches Section */}
                <div className="footer-column">
                    <h3>Popular Searches</h3>
                    <ul className="footer-list">
                        {popularSearches.map((search, index) => (
                            <li key={index}>{search}</li>
                        ))}
                    </ul>
                </div>

                {/* Company Section */}
                <div className="footer-column">
                    <h3>Company</h3>
                    <ul className="footer-list">
                        {companyLinks.map((link, index) => (
                            <li key={index}>
                                <NavLink to={link.path}>{link.label}</NavLink>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Social Media Section */}
                <div className="footer-column">
                    <h3>Connect With Us</h3>
                    <div className="social-icons">
                        {socialLinks.map((social, index) => (
                            <a
                                key={index}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={social.label}
                            >
                                <social.Icon />
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="policy-links">
                    {policyLinks.map((link, index) => (
                        <NavLink key={index} to={link.path}>
                            {link.label}
                        </NavLink>
                    ))}
                </div>
                <p className="copyright">
                    &copy; {currentYear} KhetBazaar. All Rights Reserved.
                    <br />
                    Powered by KhetBazaar Technologies Pvt. Ltd.
                </p>
            </div>
        </footer>
    );
};

export default FooterComponent;